import * as React from "react";

function ViewerListContextIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={20.283} height={19.932} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.283 19.932" {...props}>
      <g fillOpacity={1} fill="currentColor" fillRule="nonzero">
        <path d="M9.96 19.922c5.499 0 9.962-4.463 9.962-9.961S15.459 0 9.96 0 0 4.463 0 9.96c0 5.499 4.463 9.962 9.96 9.962Zm0-1.66c-4.589 0-8.3-3.711-8.3-8.301s3.711-8.3 8.3-8.3c4.59 0 8.302 3.71 8.302 8.3 0 4.59-3.711 8.3-8.301 8.3Z" />
        <path d="M4.648 8.037h10.645c.43 0 .742-.273.742-.693 0-.41-.312-.684-.742-.684H4.648c-.439 0-.742.274-.742.684 0 .42.303.693.742.693Zm1.446 3.232h7.754c.43 0 .732-.273.732-.693 0-.41-.303-.683-.732-.683H6.094c-.44 0-.742.273-.742.683 0 .42.302.694.742.694Zm1.504 3.243h4.736c.43 0 .742-.284.742-.694s-.312-.683-.742-.683H7.598c-.43 0-.733.273-.733.683 0 .41.303.694.733.694Z" />
      </g>
    </svg>
  );
}

export default ViewerListContextIcon;
